<template>
  <div v-show="showCard" class="subject-card-container">
    <button class="close-button" @click="closeCard">X</button>
    <span class="subject-code">{{ subjectData.code }}</span>
    <span class="subject-name">{{ subjectData.name }}</span>
    <a
      class="jupiter-subject-link"
      :href="
        `https://uspdigital.usp.br/jupiterweb/obterDisciplina?sgldis=${subjectData.code}`
      "
    >
      Matéria no Júpiter
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    showCard() {
      return this.$store.state.showSubjectCard;
    },
    subjectData() {
      return this.$store.state.subjectCardData;
    }
  },
  methods: {
    closeCard() {
      this.$store.dispatch("hideSubjectCard");
      this.$store.dispatch("resetSubjectCardData");
    }
  }
};
</script>

<style>
.subject-card-container {
  background-color: #07689f;
  width: 250px;
  font-family: "Montserrat";
  @apply flex flex-col items-center
  fixed top-0 right-0 p-3 mt-3 mr-3
  text-white rounded-xl;
}

.close-button {
  background-color: #044164;
  @apply absolute top-0 right-0 w-6 h-6 mt-2 mr-2 rounded-full;
}

.close-button:hover {
  background-color: #03293f;
}

.subject-code {
  @apply text-3xl;
}

.subject-name {
  @apply mt-3 text-xl text-center;
}

.jupiter-subject-link {
  color: #f6ae2d;
  @apply mt-3 font-bold cursor-pointer;
}

.jupiter-subject-link:hover {
  @apply underline;
}
</style>
